module.exports = __webpack_public_path__ + "static/media/26.5c04a5de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/26.jpg
// module id = 587
// module chunks = 0